import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Protects routes that require login
// If the user is not logged in, redirects to the home page
// Otherwise, renders the requested component

const PrivateRoute = ({ element }) => {
    const {isLoggedIn} = useAuth();
    if (!isLoggedIn) {
        console.log("redirect");
        return <Navigate to="/" />;
    }
    return element;
};
export default PrivateRoute;